import React from 'react';
import {
  getPrescriptionFrequencyLabel,
  getPrescriptionRouteLabel
} from '../utils/prescriptionOptions';

const ReportPrescriptions = ({ items, title, description, emptyMessage, t }) => {
  const prescriptionItems = Array.isArray(items) ? items : [];

  return (
    <section className="report-prescriptions" aria-labelledby="report-prescriptions-title">
      <div className="report-prescriptions__heading">
        <h4 id="report-prescriptions-title" className="report-subsection-title">{title}</h4>
        <p>{description}</p>
      </div>

      {prescriptionItems.length > 0 ? (
        <div className="prescription-table-shell">
          <table className="prescription-table prescription-table--readonly">
            <thead>
              <tr>
                <th scope="col">{t('reports.prescriptionDrugCode')}</th>
                <th scope="col">{t('reports.prescriptionDrugName')}</th>
                <th scope="col">{t('reports.prescriptionSpecification')}</th>
                <th scope="col">{t('reports.prescriptionAdministrationRoute')}</th>
                <th scope="col">{t('reports.prescriptionFrequency')}</th>
                <th scope="col">{t('reports.prescriptionSingleDose')}</th>
              </tr>
            </thead>
            <tbody>
              {prescriptionItems.map((item) => (
                <tr key={item.id}>
                  <td>{item.drug_code}</td>
                  <td className="prescription-table__drug-name">{item.drug_name}</td>
                  <td>{item.specification}</td>
                  <td>{getPrescriptionRouteLabel(item.administration_route, t)}</td>
                  <td>{getPrescriptionFrequencyLabel(item.frequency, t)}</td>
                  <td>{item.single_dose}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="report-prescriptions__empty">{emptyMessage}</p>
      )}
    </section>
  );
};

export default ReportPrescriptions;
